

export const deleteDuplicate = function (arr1, arr2) {
  arr2.forEach(item => {
    let index = arr1.indexOf(item)
    index > -1 ? arr1.splice(index, 1) : ''
  });
  return arr1
};

export function getParam(name, href) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var realparams = window.location.search.substr(1);
  if (href && href.indexOf("?") > -1) {
    realparams = href.split("?")[1];
  }
  var r = realparams.match(reg);

  if (r != null) return decodeURIComponent(r[2]);
  return '';
}